import styled from 'styled-components'

export const ModalHeader = styled.div`
  width: 100%;
  background-color: ${props => props.theme.h1New};
  padding: 18px 24px;
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
`
